exports.components = {
  "component---src-pages-help-js": () => import("./../../../src/pages/help.js" /* webpackChunkName: "component---src-pages-help-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("./../../../src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-onas-js": () => import("./../../../src/pages/onas.js" /* webpackChunkName: "component---src-pages-onas-js" */),
  "component---src-pages-vlozka-js": () => import("./../../../src/pages/vlozka.js" /* webpackChunkName: "component---src-pages-vlozka-js" */),
  "component---src-pages-zamek-js": () => import("./../../../src/pages/zamek.js" /* webpackChunkName: "component---src-pages-zamek-js" */)
}

